module.exports = __webpack_public_path__ + "img/T711.bf480715.jpg";